import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import ja from "../locales/ja.json";
import en from "../locales/en.json";

const STORAGE_KEY = "musubi.locale";

function detectInitialLocale(): "ja" | "en" {
  const saved = typeof window !== "undefined" ? localStorage.getItem(STORAGE_KEY) : null;
  if (saved === "ja" || saved === "en") return saved;
  if (typeof navigator !== "undefined" && navigator.language?.startsWith("ja")) return "ja";
  return "en";
}

void i18n.use(initReactI18next).init({
  resources: {
    ja: { translation: ja },
    en: { translation: en },
  },
  lng: detectInitialLocale(),
  fallbackLng: "ja",
  interpolation: { escapeValue: false },
  returnNull: false,
});

export function setLocale(lng: "ja" | "en") {
  void i18n.changeLanguage(lng);
  if (typeof window !== "undefined") localStorage.setItem(STORAGE_KEY, lng);
  document.documentElement.lang = lng === "ja" ? "ja" : "en";
}

export default i18n;
